import { Skeleton, Stack } from "@mui/material";

function ToolbarSkeleton() {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      gap={2}
      flexWrap="wrap"
      sx={{ width: "100%" }}
    >
      <Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
        <Skeleton
          variant="rectangular"
          width={300}
          height={56}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={182}
          height={48}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={182}
          height={48}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={182}
          height={48}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={182}
          height={48}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={80}
          height={38}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={48}
          height={38}
          sx={{ borderRadius: "5px" }}
        />
      </Stack>

      {/* Botones derecha */}
      <Stack direction="row" alignItems="center" gap={2}>
        <Skeleton
          variant="rectangular"
          width={100}
          height={38}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={100}
          height={38}
          sx={{ borderRadius: "5px" }}
        />
        <Skeleton
          variant="rectangular"
          width={120}
          height={38}
          sx={{ borderRadius: "5px" }}
        />
      </Stack>
    </Stack>
  );
}

function StatsSkeleton() {
  return (
    <Stack direction="row" gap={4} sx={{ overflowX: "auto" }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          width="100%"
          height={120}
          sx={{ borderRadius: "5px", minWidth: "220px" }}
        />
      ))}
    </Stack>
  );
}

export default function CampaignManagerSkeletons() {
  return (
    <Stack spacing={2} sx={{ padding: 2, paddingBottom: 0 }}>
      <ToolbarSkeleton />
      <StatsSkeleton />
      <Skeleton
        variant="rectangular"
        width="100%"
        height="calc(100vh - 400px)"
        sx={{ borderRadius: "5px", minHeight: "400px" }}
      />
    </Stack>
  );
}
